import { DropdownButtonType, FilteringList, ListItem, SingleSelectDropdown } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '~src/codegen/Localize';
import { ScheduleActions } from '~src/schedule/types/ISchedule';
import { IScheduleInfo } from '~src/schedule/types/IScheduleInfo';
import { SliceableHelper } from '~src/ts/helpers/SliceableHelper';
import { SchedulesService } from '~src/ts/resources/Schedules';

const filteringListStyle: React.CSSProperties = {
  maxHeight: '200px',
  paddingLeft: 0,
  paddingRight: 0,
  overflowY: 'auto'
};

function createListItem(item: IScheduleInfo): ListItem {
  const scheduleText = `${item.name} \u2014 ${IScheduleInfo.getScheduleDescription(item)}`;
  return {
    content: scheduleText,
    tooltip: scheduleText,
    value: item.id
  };
}

export const PublishedConnectionTaskSchedulePicker: React.FC<{
  readonly scheduleId: string;
  readonly onSelect: (value: string) => void;
  readonly label?: string;
}> = ({ scheduleId, onSelect, label }) => {

  const [listItems, setListItems] = React.useState<ReadonlyArray<ListItem>>([]);
  const [filteredList, setFilteredList] = React.useState<ListItem []>([]);
  const [searchText, setSearchText] = React.useState<string>('');

  React.useEffect(() => {
      const schedulesQuery = SchedulesService.all();
      const filteredSchedules = schedulesQuery.addFilter(SchedulesService.filterByActionType(ScheduleActions.Extract));
      SliceableHelper.fetchAll(filteredSchedules).then(schedules => {
        const listItems: ListItem[] = [];
        schedules.items.forEach((item) => {
          listItems.push(createListItem(item));
        });
        setListItems(listItems);
        setFilteredList(listItems);
      });
    },
    []
  );

  const handleFilterChange = React.useCallback(
    (filterValue: string) => {
      const filteredList = listItems.filter(item => {
        return item.content && (item.content as string).toLowerCase().indexOf(filterValue.toLowerCase()) >= 0;
      });
      setFilteredList(filteredList);
      setSearchText(filterValue);
    },
    [listItems]
  );

  const scheduleText = React.useMemo(
    (): string => {
      return (scheduleId && listItems.length !== 0)
        ? listItems.find(item => item.value === scheduleId).content as string
        : Messages.selectASchedule();
    },
    [listItems, scheduleId]
  );

  return (
    <SingleSelectDropdown
      list={<FilteringList
        items={filteredList}
        inputTestId='published-connection-task-schedule-picker'
        listTestId='published-connection-task-schedule-picker-list'
        searchPlaceholder={Messages.search()}
        onFilterChange={handleFilterChange}
        searchText={searchText}
        style={filteringListStyle}
      />}
      value={scheduleId}
      type={DropdownButtonType.Outline}
      onChange={onSelect}
      label={label}
    >
      <div style={{ whiteSpace: 'nowrap' }}>{scheduleText}</div>
    </SingleSelectDropdown>
  );
};
PublishedConnectionTaskSchedulePicker.displayName = 'PublishedConnectionTaskSchedulePicker';
